<mat-icon class="material-icons-outlined article-type-icon" [mpIcon]="icon" />
@if (hasMatch) {
  <mat-icon class="match-icon">link</mat-icon>
}
